var map = {
	"./top1.svg": 28986,
	"./top10.svg": 52870,
	"./top2.svg": 44073,
	"./top3.svg": 9208,
	"./top4.svg": 29015,
	"./top5.svg": 41478,
	"./top6.svg": 40613,
	"./top7.svg": 85892,
	"./top8.svg": 24435,
	"./top9.svg": 61794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53655;